import { useEffect, useState } from "react";

import { projects } from "@/data/projects";

/** Cover/gallery images, each shown once, in project order. */
const frames = [
  ...new Set(
    projects
      .flatMap((p) => [p.cover, ...p.images.map((i) => i.src)])
      .filter(Boolean),
  ),
].slice(0, 16);

const SEEN_KEY = "ljp-intro-seen";

export function IntroOverlay() {
  const [frame, setFrame] = useState(0);
  const [phase, setPhase] = useState<"idle" | "flash" | "word" | "done">("idle");

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.localStorage.getItem(SEEN_KEY)) {
      setPhase("done");
      return;
    }
    window.localStorage.setItem(SEEN_KEY, "1");
    setPhase("flash");
    document.body.style.overflow = "hidden";

    const tick = window.setInterval(() => setFrame((f) => f + 1), 110);
    const toWord = window.setTimeout(() => {
      window.clearInterval(tick);
      setPhase("word");
    }, 2200);
    const toDone = window.setTimeout(() => setPhase("done"), 4600);

    return () => {
      window.clearInterval(tick);
      window.clearTimeout(toWord);
      window.clearTimeout(toDone);
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    if (phase === "done") document.body.style.overflow = "";
  }, [phase]);

  if (phase === "done" || phase === "idle") return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-ink ${
        phase === "word" ? "intro-exit" : ""
      }`}
    >
      {phase === "flash" ? (
        <>
          {frames.map((src, i) => (
            <img
              key={src}
              src={src}
              alt="Luiza Jesus do Prado — still from a work"
              aria-hidden
              className={`absolute inset-0 h-full w-full object-cover contrast-125 ${
                i === frame % frames.length ? "opacity-100" : "opacity-0"
              }`}
            />
          ))}
          <div className="absolute inset-0 bg-ink/45" />
          <span className="relative block text-center font-didone leading-[0.9] text-bone">
            <span className="block text-[clamp(2rem,6vw,4.5rem)] font-medium tracking-[0.02em]">
              Luiza
            </span>
            <span className="-mt-[0.04em] block text-[clamp(1.7rem,5vw,3.8rem)] font-light italic tracking-[0.02em] text-bone/90">
              Jesus do Prado
            </span>
          </span>
        </>
      ) : (
        <div className="relative">
          <span className="jesus-word font-display text-[clamp(3.5rem,18vw,17rem)] uppercase leading-none text-red">
            <span className="relative inline-block">
              J<i className="strike strike-1" />
            </span>
            ESU
            <span className="relative inline-block">
              S<i className="strike strike-2" />
            </span>
          </span>
        </div>
      )}
    </div>
  );
}
